module.exports = __webpack_public_path__ + "img/220805114232.6648886c.jpg";